import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'submit-application-review',
  template: require('./submit-application-review.component.html')
})

export class SubmitApplicationReviewComponent extends BaseRoute {

  constructor(injector: Injector) {
    super(injector);
    this.reviewData = this.route.data.value.reviewObj.reviewData;
    this.sections = this.route.data.value.reviewObj.sections;
    if (this.sections.length > 0) this.expanded = this.sections[0];

    // Reset prepop state for navigation so that they go through the entire flow
    this.flowManager.prepoppedValid = false;
  }

  next() {
    this.loadingNext = true;
  }

  expandSection(section) {
    this.expanded = section;
  }

  objKeys(obj) {
    return Object.keys(obj);
  }
}
